import React from 'react';
import logo from '../../images/logo-2.png'
import leftArrow from '../../images/left-arrow.svg'

class Header extends React.Component {

  render() {
    return(
      <header className="header site-header">
        <div className="logo-cont">
          <a rel="noopener noreferrer" href={`${this.props.stringData.string_29}`} target="_blank" rel="noopener noreferrer">
            <img className="logo" src={logo} alt="Logo"/>
          </a>
        </div>
        <div className="text-cont">
          <h1>{this.props.title}</h1> 
        </div>

        <div className="button-cont">
          {this.props.activeInitialBaseplate &&
            <button className="btn" onClick={() => {
              let r = window.confirm("Changes you've made will not be saved");
							if (r == true) {
								this.props.resetActiveBaseplateState()
							}
              }}>
              <img src={leftArrow} />
              Back to Baseplate Selection
            </button>
          }
        </div>
      </header>
    );
  }
}

export default Header;